import React from 'react'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { MeetingRoomForm } from 'domain/feature/hub/company/meeting-room/manage-meeting-room/MeetingRoomForm'
import { IMeetingRoomFormData } from 'domain/feature/hub/company/meeting-room/manage-meeting-room/types'
import {
  useSaveMeetingRoom,
} from 'domain/feature/hub/company/meeting-room/manage-meeting-room/hooks/useSaveMeetingRoom'
import { showToast } from 'components/toast'
import { getHubRoute } from 'sharedKernel/handlers'
import { ROUTES } from 'sharedKernel/constants'
import { trans } from 'sharedKernel/i18n'

export const HubCompanyNewMeetingRoomPage = (): JSX.Element => {
  const navigate = useNavigate()
  const { save, isLoading } = useSaveMeetingRoom()

  const handleSave = async (data: IMeetingRoomFormData): Promise<void> => {
    await save(data)
    showToast('success', trans('meetingRoom.toast.createSuccess'))
    navigate(getHubRoute(ROUTES.HUB.COMPANY.MEETING_ROOM_MANAGE))
  }

  return <MeetingRoomForm onSave={handleSave} isSaving={isLoading} />
}
